export const workLogListRoute = {
  path: "/work-log",
  name: "work-log-list",
  component: () => import("../ui/work-log/work-log-list.vue")
};